export default __webpack_public_path__ + "static/media/logo-instragram.dcf5a12d.png";